import { FieldError } from 'react-hook-form';

export const getErrorFromFieldState = (
  error: FieldError | undefined
): { code: string }[] | undefined => {
  if (!error) return undefined;
  return [{ code: error.message || 'required' }];
};
